import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DriverLicenceEntitlement } from '../../../model/licence.model';

@Component({
  selector: 'vrm-licence-entitlements-table',
  templateUrl: './licence-entitlements-table.component.html',
  styleUrls: ['./licence-entitlements-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LicenceEntitlementsTableComponent {
  @Input() public licenceType: string = null;
  @Input() public dataSource: DriverLicenceEntitlement[] = [];
  protected columns = ['commenceDate', 'expiryDate', 'offenceCode', 'identifier', 'restrictionCodes', 'description'];
}
